
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 225 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f93","d":"M0 0h225v150H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 50h225v50H0z"}}),_c('path',{attrs:{"fill":"#128807","d":"M0 100h225v50H0z"}}),_c('g',{attrs:{"transform":"translate(112.5 75)"}},[_c('circle',{attrs:{"r":"20","fill":"#008"}}),_c('circle',{attrs:{"r":"17.5","fill":"#fff"}}),_c('circle',{attrs:{"r":"3.5","fill":"#008"}}),_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('g',{attrs:{"id":"a","fill":"#008"}},[_c('circle',{attrs:{"r":".875","transform":"rotate(7.5 -8.75 133.5)"}}),_c('path',{attrs:{"d":"M0 17.5L.6 7 0 2l-.6 5L0 17.5z"}})]),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(15)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(30)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(60)"}})]),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(120)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(-120)"}})])])
          )
        }
      }
    